import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ContractLiteInterface, IdInterface } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetContractsUseCaseParams {
    code: IdInterface;
}

@Injectable()
export class GetContractsUseCase implements UseCaseWithParam<GetContractsUseCaseParams, Observable<Transaction<ContractLiteInterface[]>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(params: GetContractsUseCaseParams): Observable<Transaction<ContractLiteInterface[]>> {
        return this.contractProvider.all(params.code).pipe(
            map((transaction) =>
                transaction.map(
                    (contracts) => Transaction.success(cloneDeep(contracts)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
